export const buttonLinkText = (mentionType: 'User' | 'Article') =>
  mentionType === 'User' ? 'Open Profile' : 'Open Doc'

export const commentAriaLabel = 'A button that displays the comments left on a card.'
export const taskAriaLabel = 'A button that displays the tasks left on a card.'
